namespace SPA
{
	export namespace gui
	{
		export namespace address
		{
			export class AddressItem extends ui.base.BaseHTMLElement
			{

				private m_Address: Wollmilch.AddressObject;

				public constructor( _address: Wollmilch.AddressObject )
				{
					super( 'address' );

					this.m_Address = _address;

					this.css(
						{
							'border-bottom': '1px dashed RGBA( 0, 0, 0, 0.15 )'
						}
					);
				}

				public rebuild( root: JQuery | ui.base.BaseHTMLElement ): AddressItem
				{
					this.empty();
					this.remove();

					this.appendTo( root );

					switch ( this.m_Address.AddressType )
					{
						case 'PostalAddress':
							this.buildPostalAddress( this.m_Address as Wollmilch.PostalAddressObject );
							break;
						case 'POBox':
							this.buildPOBox( this.m_Address as Wollmilch.POBoxObject );
							break;
						case 'Fax':
							this.buildFax( this.m_Address as Wollmilch.FaxAddressObject );
							break;
						case 'Phone':
							this.buildPhone( this.m_Address as Wollmilch.PhoneAddressObject );
							break;
						case 'Email':
							this.buildEmail( this.m_Address as Wollmilch.EmailAddressObject );
							break;
					}

					return this;
				}

				private buildPostalAddress( adr: Wollmilch.PostalAddressObject ): void
				{
					this
					.append(
						ui.$$.span().text( 'Straße Hausnummer: ' ).css( 'font-weight', 'bold' )
					)
					.append(
						ui.$$.span().text( adr.Street + " " + adr.HouseNumber )
					);
					this.append( ui.$$.br() );
					this
					.append(
						ui.$$.span().text( 'PLZ, Stadt: ' ).css( 'font-weight', 'bold' )
					)
					.append(
						ui.$$.span().text( adr.PostalCode + ', ' + adr.City )
					);
					if ( adr.Country && !adr.State )
					{
						this.append( ui.$$.br() );
						this
						.append(
							ui.$$.span().text( 'Staat: ' ).css( 'font-weight', 'bold' )
						)
						.append(
							ui.$$.span().text( adr.Country )
						);
					}
					else if ( adr.Country && adr.State )
					{
						this.append( ui.$$.br() );
						this
						.append(
							ui.$$.span().text( 'Staat (Bundesland): ' ).css( 'font-weight', 'bold' )
						)
						.append(
							ui.$$.span().text( adr.Country + ' (' + adr.State + ')' )
						);
					}
				}

				private buildPOBox( adr: Wollmilch.POBoxObject ): void
				{
					this
					.append(
						ui.$$.span().text( 'Postfach: ' ).css( 'font-weight', 'bold' )
					)
					.append(
						ui.$$.span().text( adr.Box )
					);
					this.append( ui.$$.br() );
					this
					.append(
						ui.$$.span().text( 'PLZ, Stadt: ' ).css( 'font-weight', 'bold' )
					)
					.append(
						ui.$$.span().text( adr.PostalCode + ', ' + adr.City )
					);
					if ( adr.Country && !adr.State )
					{
						this.append( ui.$$.br() );
						this
						.append(
							ui.$$.span().text( 'Staat: ' ).css( 'font-weight', 'bold' )
						)
						.append(
							ui.$$.span().text( adr.Country )
						);
					}
					else if ( adr.Country && adr.State )
					{
						this.append( ui.$$.br() );
						this
						.append(
							ui.$$.span().text( 'Staat (Bundesland): ' ).css( 'font-weight', 'bold' )
						)
						.append(
							ui.$$.span().text( adr.Country + ' (' + adr.State + ')' )
						);
					}
				}

				private buildFax( adr: Wollmilch.FaxAddressObject ): void
				{
					this
					.append(
						ui.$$.span().text( 'Telefax: ' ).css( 'font-weight', 'bold' )
					)
					.append(
						ui.$$.span().text( adr.display )
					);
				}

				private buildPhone( adr: Wollmilch.PhoneAddressObject ): void
				{
					this
					.append(
						ui.$$.span().text( 'Telefon: ' ).css( 'font-weight', 'bold' )
					)
					.append(
						ui.$$.a().text( adr.display ).attr(
							{
								href: 'tel:' + adr.display
							}
						)
					);
				}

				private buildEmail( adr: Wollmilch.EmailAddressObject ): void
				{
					this
					.append(
						ui.$$.span().text( 'Email: ' ).css( 'font-weight', 'bold' )
					)
					.append(
						ui.$$.a().text( adr.display ).attr(
							{
								href: 'mailto:' + adr.display
							}
						)
					);
				}

			}
		}
	}
}
